import React from 'react'

import Icon, { IconProps } from './Icon'

/**
 * GPSアイコン
 */
const GpsIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
      >
        <path
          d="M8,5.455A2.545,2.545,0,1,0,10.545,8,2.545,2.545,0,0,0,8,5.455Zm5.689,1.909A5.724,5.724,0,0,0,8.636,2.311V1H7.364V2.311A5.724,5.724,0,0,0,2.311,7.364H1V8.636H2.311a5.724,5.724,0,0,0,5.053,5.053V15H8.636V13.689a5.724,5.724,0,0,0,5.053-5.053H15V7.364H13.689ZM8,12.455A4.455,4.455,0,1,1,12.455,8,4.451,4.451,0,0,1,8,12.455Z"
          transform="translate(-1 -1)"
        />
      </svg>
    </Icon>
  )
}

export default GpsIcon
